export const iniciarChatWhatsApp = ({numero, mensaje=''}) => {

    let texto = decodeURI(mensaje)
    window.open(`https://api.whatsapp.com/send?phone=57${numero}&text=${texto}`)
}